module.exports = __webpack_public_path__ + "assets/a-shuben3.1612d4cd.svg";